<template>
  <div>
    <loader v-if="!verificationData" :loader="loader"></loader>
    <div v-else class="verify__container">
      <div class="success__wrap" v-if="success">
        <span class="success">{{ successMessage }}</span>
        <svgicon icon="cancel" class="success__icon"></svgicon>
      </div>

      <div class="dashboard__manageListing-top">
        <router-link
          :to="`/verify?page=${curPage}`"
          tag="p"
          class="dashboard__back"
          >Back</router-link
        >
        <p
          class="listing__status"
          style="margin-bottom: 48px"
          v-if="verificationData"
          :class="[
            { pending: status == 'pending' },
            { verified: status == 'completed' },
            { unverified: status == 'unverified' }
          ]"
        >
          {{ status | capitalize }}
        </p>
      </div>
      <div class="dashboard__manageListing-row verify">
        <div class="verify__left">
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header">
              <p class="dashboard__manageListing-individual-heading">
                Personal Information
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
              v-if="personalDetails != null"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Tenant Name
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{
                    `${personalDetails.firstName} ${personalDetails.lastName}`
                  }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">Email</p>
                <p class="dashboard__manageListing-individual-text">
                  {{ personalDetails.email }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Phone Number
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ personalDetails.phone }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Marital Satus
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ personalDetails.maritalStatus }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Date of Birth
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ personalDetails.dob | formatDate }}
                </p>
              </div>
            </div>
          </div>
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header">
              <p class="dashboard__manageListing-individual-heading">
                Employment Information
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
              v-if="employmentDetails != null"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Employment Status
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ employmentDetails.employmentStatus }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Name of Comapny
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ employmentDetails.companyName }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Role in Comapny
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ employmentDetails.role }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Date Joined
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ employmentDetails.dateJoined | formatDate }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Company Address
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ employmentDetails.companyAddress }}
                </p>
              </div>
            </div>
          </div>
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header">
              <p class="dashboard__manageListing-individual-heading">
                Next of Kin
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
              v-if="nextOfKin != null"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Relationship
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ nextOfKin.relationship }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">Name</p>
                <p class="dashboard__manageListing-individual-text">
                  {{ `${nextOfKin.firstName} ${nextOfKin.lastName}` }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Phone number
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ nextOfKin.phone }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Email
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ nextOfKin.email }}
                </p>
              </div>
            </div>
          </div>
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header">
              <p class="dashboard__manageListing-individual-heading">
                Guarantor Information
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
              v-if="guarantor != null"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Name of Guarantor
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ `${guarantor.firstName} ${guarantor.lastName}` }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Employment Status
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ guarantor.employmentStatus }}
                </p>
              </div>
              <div
                v-show="guarantor.employmentStatus !== 'student'"
                class="dashboard__manageListing-individual-info"
              >
                <p class="dashboard__manageListing-individual-title">
                  Company
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ guarantor.company }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Phone number
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ guarantor.phone }}
                </p>
              </div>
              <div
                v-show="guarantor.employmentStatus !== 'student'"
                class="dashboard__manageListing-individual-info"
              >
                <p class="dashboard__manageListing-individual-title">
                  Company Address
                </p>
                <p class="dashboard__manageListing-individual-text">
                  {{ guarantor.address }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="verify__right">
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header row">
              <p class="dashboard__manageListing-individual-heading col">
                Identity Verification
              </p>
              <p
                class="listing__status mb-0"
                v-if="personalDetails != null"
                :class="[
                  {
                    pending: personalDetails.idVerificationStatus == null
                  },
                  {
                    verified: personalDetails.idVerificationStatus == 'verified'
                  },
                  {
                    unverified:
                      personalDetails.idVerificationStatus == 'unverified'
                  }
                ]"
              >
                {{
                  personalDetails.idVerificationStatus || "pending" | capitalize
                }}
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Identification Type
                </p>
                <p
                  v-show="personalDetails.identificationFront"
                  class="dashboard__manageListing-individual-title"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.4392 0.956075L3.72666 0.956075C2.25333 0.950408 1.04562 2.12483 1.01091 3.59745L1.01091 11.1858C0.978326 12.6825 2.16478 13.9228 3.66149 13.9561C3.68345 13.9561 3.7047 13.9568 3.72666 13.9561L9.38553 13.9561C10.8688 13.8959 12.0375 12.6705 12.0269 11.1858L12.0269 4.69324L8.4392 0.956075Z"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25293 0.947754V3.0083C8.25293 4.01413 9.0661 4.82942 10.0719 4.83225H12.0234"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.1209 9.87858H4.2959"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.67209 7.22087H4.29492"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span @click="handleIdDownload" class="id_type"
                    >National Identity Number</span
                  >
                </p>
              </div>
              <div
                v-show="personalDetails.idVerificationStatus !== 'verified'"
                class="action_container"
              >
                <button
                  type="button"
                  class="v_btn outline_blue"
                  @click="handleIdUpdate"
                >
                  <svgicon
                    icon="spinner"
                    v-if="showIdConfirmLoader"
                    class="button__loader_blue"
                  ></svgicon>
                  Confirm
                </button>
                <button
                  type="button"
                  class="v_btn outline_red"
                  @click="toggleRejectBox('id')"
                >
                  Reject
                </button>
              </div>
              <div v-show="idIsRejected">
                <textarea
                  class="listing__textarea p-3 w-100 "
                  v-model="idRejectReason"
                  placeholder="Enter the reason for rejection"
                ></textarea>
                <button
                  :disabled="!idRejectReason"
                  type="button"
                  class="dashboard__booking-profile-decline rejectBtn"
                  @click="handleIdUpdate"
                >
                  <svgicon
                    icon="spinner"
                    v-if="showIdRejectLoader"
                    class="button__loader_red"
                  ></svgicon>
                  Reject
                </button>
              </div>
            </div>
          </div>
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header row">
              <p class="dashboard__manageListing-individual-heading col">
                Address Verification
              </p>
              <p
                class="listing__status mb-0"
                v-if="personalDetails != null"
                :class="[
                  {
                    pending: personalDetails.addressStatus == null
                  },
                  {
                    verified: personalDetails.addressStatus == 'approved'
                  },
                  {
                    unverified: personalDetails.addressStatus == 'rejected'
                  }
                ]"
              >
                {{ personalDetails.addressStatus || "pending" | capitalize }}
              </p>
            </div>
            <div
              v-if="personalDetails != null"
              class="dashboard__manageListing-individual-content verify__content"
            >
              <div
                class="dashboard__manageListing-individual-info verify__info"
              >
                <p class="dashboard__manageListing-individual-title">
                  Home Address
                </p>
                <p class="dashboard__manageListing-individual-title left">
                  {{ personalDetails.address }}
                </p>
              </div>
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Identification Type
                </p>
                <p
                  v-show="personalDetails.utilityBillUrl"
                  class="dashboard__manageListing-individual-title"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.4392 0.956075L3.72666 0.956075C2.25333 0.950408 1.04562 2.12483 1.01091 3.59745L1.01091 11.1858C0.978326 12.6825 2.16478 13.9228 3.66149 13.9561C3.68345 13.9561 3.7047 13.9568 3.72666 13.9561L9.38553 13.9561C10.8688 13.8959 12.0375 12.6705 12.0269 11.1858L12.0269 4.69324L8.4392 0.956075Z"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25293 0.947754V3.0083C8.25293 4.01413 9.0661 4.82942 10.0719 4.83225H12.0234"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.1209 9.87858H4.2959"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.67209 7.22087H4.29492"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span @click="handleUtilityDownload" class="id_type"
                    >Utility Bill</span
                  >
                </p>
              </div>
              <div 
                v-if="addressStatus"
                class="action_container"
              >
                <button
                  type="button"
                  class="v_btn outline_blue"
                  @click="handleAddressStatusUpdate"
                >
                  <svgicon
                    icon="spinner"
                    v-if="showAddressConfirmLoader"
                    class="button__loader_blue"
                  ></svgicon>
                  Confirm
                </button>
                <button
                  type="button"
                  class="v_btn outline_red"
                  @click="toggleRejectBox('address')"
                >
                  Reject
                </button>
              </div>
              <div class="verification_reason">
                {{ personalDetails.autoAddressVerificationFailureReason }}
              </div>
              <div v-show="addressIsRejected">
                <textarea
                  class="listing__textarea p-3 w-100 "
                  v-model="addressRejectReason"
                  placeholder="Enter the reason for rejection"
                ></textarea>
                <button
                  :disabled="!addressRejectReason"
                  type="button"
                  class="v_btn outline_red"
                  @click="handleAddressStatusUpdate"
                >
                  <svgicon
                    icon="spinner"
                    v-if="showAddressRejectLoader"
                    class="button__loader_red"
                  ></svgicon>
                  Reject
                </button>
              </div>
            </div>
          </div>
          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header row">
              <p class="dashboard__manageListing-individual-heading col">
                Afffordability Data
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
            >
              <div class="chart">
                <div class="outer_blue">
                  <div class="inner_white">
                    <div class="score__container">
                      <p class="score">{{ creditScore }}</p>
                      <p class="total">out of 900</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- This input field below was created for an admin to give extra information on the credit score, and approve but now the information comes from the api  -->
              <!-- <div>
                <textarea
                  class="listing__textarea p-3 w-100 "
                  v-model="rejectReason"
                  placeholder="Enter additional information"
                ></textarea>
                <button
                  type="button"
                  class="v_btn outline_blue"
                  @click="handleCreditScoreRejection"
                >
                  <svgicon
                    icon="spinner"
                    v-if="showCreditScoreLoader"
                    class="button__loader_red"
                  ></svgicon>
                  Submit
                </button>
              </div> -->
            </div>
          </div>

          <div class="dashboard__manageListing-individual details">
            <div class="dashboard__manageListing-individual-header row">
              <p class="dashboard__manageListing-individual-heading col">
                Background Check
              </p>
            </div>
            <div
              class="dashboard__manageListing-individual-content verify__content"
            >
              <div class="dashboard__manageListing-individual-info">
                <p class="dashboard__manageListing-individual-title">
                  Background Check
                </p>
                <p class="dashboard__manageListing-individual-title">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.4392 0.956075L3.72666 0.956075C2.25333 0.950408 1.04562 2.12483 1.01091 3.59745L1.01091 11.1858C0.978326 12.6825 2.16478 13.9228 3.66149 13.9561C3.68345 13.9561 3.7047 13.9568 3.72666 13.9561L9.38553 13.9561C10.8688 13.8959 12.0375 12.6705 12.0269 11.1858L12.0269 4.69324L8.4392 0.956075Z"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25293 0.947754V3.0083C8.25293 4.01413 9.0661 4.82942 10.0719 4.83225H12.0234"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.1209 9.87858H4.2959"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.67209 7.22087H4.29492"
                      stroke="#130F26"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="id_type">Document.pdf</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getVerificationDetail,
  updateAddressStatus,
  updateIdStatus
} from "../../../services/verify";
import loader from "../resuables/loader";

export default {
  name: "verifyDetails",
  components: {
    loader
  },
  data() {
    return {
      id: "",
      success: false,
      successMessage: "",
      verificationId: this.$route.params.id,
      loader: false,
      showIdRejectLoader: false,
      showAddressRejectLoader: false,
      showCreditScoreLoader: false,
      showIdConfirmLoader: false,
      showAddressConfirmLoader: false,
      verificationData: null,
      idRejectReason: "",
      addressRejectReason: "",
      rejectReason: "",
      idIsRejected: false,
      addressIsRejected: false
    };
  },
  computed: {
    curPage() {
      return this.$route.query.page || 1;
    },
    personalDetails() {
      if (this.verificationData) {
        return this.verificationData.personalDetails;
      }
      return null;
    },
    employmentDetails() {
      if (this.verificationData) {
        return this.verificationData.employmentDetails;
      }
      return null;
    },
    nextOfKin() {
      if (this.verificationData) {
        return this.verificationData.nextOfKin;
      }
      return null;
    },
    guarantor() {
      if (this.verificationData) {
        return this.verificationData.guarantor;
      }
      return null;
    },
    creditScore() {
      if (this.verificationData) {
        return this.verificationData.creditScore || 0;
      }
      return 0;
    },
    status() {
      if (this.verificationData) {
        return this.verificationData.verificationRequest.status;
      }
      return null;
    },
    addressStatus(){
      if(this.personalDetails.addressStatus == null){
        return true
      } else {
        return false 
      }
    }

  },
  mounted() {
    this.getVerification();
  },
  methods: {
    handleIdDownload() {
      this.downloadFile(this.personalDetails.identificationFront, "ID");
    },
    handleUtilityDownload() {
      this.downloadFile(this.personalDetails.utilityBillUrl, "Utility Bill");
    },
    downloadFile(file, fileName) {
      const link = document.createElement("a");
      link.href = file;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async handleAddressStatusUpdate() {
      try {
        let response;
        let payload;
        if (this.addressIsRejected) {
          payload = {
            addressStatus: "rejected",
            addressRejectReason: this.addressRejectReason
          };
          this.showAddressRejectLoader = true;
        } else {
          payload = {
            addressStatus: "approved"
          };
          this.showAddressConfirmLoader = true;
        }
        response = await updateAddressStatus(this.id, payload);
        console.log(response);
        if (response.statusCode === 200) {
          this.getVerification();
          this.$notification.success({
            message: response.message
          });
          if (this.addressIsRejected) {
            this.addressRejectReason = "";
            this.addressIsRejected = false;
          }
        }
      } catch (error) {
        console.log(error);
        this.$notification.error({
          message: "Error"
        });
      } finally {
        this.showAddressRejectLoader = false;
        this.showAddressConfirmLoader = false;
      }
    },
    toggleRejectBox(value) {
      switch (value) {
        case "id": {
          this.idIsRejected = !this.idIsRejected;
          break;
        }
        case "address": {
          this.addressIsRejected = !this.addressIsRejected;
          break;
        }
      }
    },
    getVerification() {
      this.loader = true;
      getVerificationDetail(this.verificationId)
        .then(data => {
          console.log(data);
          if (data.statusCode === 200) {
            this.verificationData = data.data;
          }
        })
        .catch(error => {
          this.loader = false;
          // return err;
        });
    },
    async handleIdUpdate() {
      try {
        let response;
        let payload;
        if (this.idIsRejected) {
          payload = {
            idVerificationStatus: "unverified",
            idRejectReason: this.idRejectReason
          };
          this.showIdRejectLoader = true;
        } else {
          payload = {
            idVerificationStatus: "verified"
          };
          this.showIdConfirmLoader = true;
        }
        response = await updateIdStatus(this.id, payload);
        if (response.statusCode === 200) {
          this.getVerification();
          this.$notification.success({
            message: response.message
          });
          if (this.idIsRejected) {
            this.rejectReason = "";
            this.idIsRejected = false;
          }
        }
      } catch (error) {
        console.log(error);
        this.$notification.error({
          message: "Error"
        });
      } finally {
        this.showIdRejectLoader = false;
        this.showIdConfirmLoader = false;
      }
    },
    handleCreditScoreRejection() {
      //
    }
  },
  watch: {
    personalDetails(newValue) {
      if (newValue) {
        this.id = this.personalDetails.id;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/verifyDetails.vue